import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar/Navbar";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import logo from "../assets/logo.png";
const Layout = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <div>
          <Navbar />
          <div className=" px-5 min-h-[calc(100vh-4rem)]">
            <Outlet />
          </div>
        </div>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div className="flex flex-col justify-center items-center h-[100vh] w-screen bg-secondary">
          <img src={logo} alt="niagar-logo" />
        </div>
      </UnauthenticatedTemplate>
    </>
  );
};

export default Layout;
